import { parseUrlQueryString } from '../url';
import { memoizeLast } from '../misc';
import { PW_QUERY_KEY, AUTH_CODE_KEY } from '../constants/misc';
import { EmptyObject } from '../types';

const getInfoReplacer = memoizeLast((locationSearch: string, documentReferrer: string) => {
    const urlParams = parseUrlQueryString(locationSearch);
    // eslint-disable-next-line no-prototype-builtins
    return urlParams.hasOwnProperty(PW_QUERY_KEY) ||
        // eslint-disable-next-line no-prototype-builtins
        urlParams.hasOwnProperty(AUTH_CODE_KEY) ||
        documentReferrer.includes(PW_QUERY_KEY)
        ? url =>
              url
                  .replace(urlParams[PW_QUERY_KEY], '<hidden-password>')
                  .replace(urlParams[AUTH_CODE_KEY], '<hidden-code>')
        : null;
});

/**
 * [RCV-39425] The function is used to override $current_url property which is added to analtyics event automatically by mixpanel provider.
 * $current_url is a part of event properties, so the masked url should be assigned there (not to segment options).
 */
export const getMixpanelMaskedProps = (): { $current_url: string } | EmptyObject => {
    const replace = getInfoReplacer(location.search, document.referrer);
    return replace ? { $current_url: replace(location.href) } : {};
};
